import { defaultLocale, locales } from "src/config/locales";
import type { Locale } from "src/types";

export const getFormatDate = (date: string, locale = "en") => {
  return new Date(date)
    .toLocaleString(locale, { year: "numeric", month: "short", day: "numeric" })
    .replace(" г.", "");
};

const localesSet = new Set<string>(locales);
const isLocale = (value: string): value is Locale => localesSet.has(value);

export const getLocaleFromUrl = (): Locale => {
  const parts = window.location.pathname.split("/");
  return parts.find(isLocale) ?? defaultLocale;
};
